
import { mapGetters } from 'vuex'
export default {
    props: {
        item: {
            type: [Array, Object],
            default: () => {},
        },
    },
    data() {
        return {
            bankButtonLoading: false,
        }
    },
    computed: {
        ...mapGetters({
            bankAccount: 'themes/player-bank/bankAccount',
        }),
    },
    methods: {
        getLimitedName(text) {
            if (!text) return null
            const displayLimit = 30
            if (text.length > displayLimit) {
                return text.substring(0, displayLimit) + '...'
            } else {
                return text
            }
        },
    },
}
